/* Rockee Redd 2.0: page-level behavior */
(function(){
  var d=document;

  /* content injected later (filters, recommendations) should never stay hidden */
  if('MutationObserver' in window){
    var t;
    new MutationObserver(function(){
      clearTimeout(t);
      t=setTimeout(function(){
        d.querySelectorAll('product-recommendations [data-rr-reveal],#ProductGridContainer [data-rr-reveal]').forEach(function(el){
          if(!el.rrSeen){el.rrSeen=true;requestAnimationFrame(function(){el.classList.add('is-in');});}
        });
      },60);
    }).observe(d.body,{childList:true,subtree:true});
  }

  var info=d.querySelector('.product__info-container');
  var btn=info&&info.querySelector('.product-form__submit');
  if(!btn){return;}
  function btnLabel(){return btn.querySelector('span')||btn;}

  /* ---- variant clarity: name the choice, count the options, and require a pick for preference options ---- */
  var FORCE=['scent','flavor','flavour','color','colour','style','type','blend'];
  var hasParam=/[?&]variant=/.test(window.location.search);
  var pending={},started=false;
  function picker(){return info.querySelector('variant-selects,variant-radios');}
  function firstPending(){for(var k in pending){if(pending[k]){return k;}}return null;}

  function decorate(){
    var p=picker();
    if(!p){return;}
    p.querySelectorAll('fieldset').forEach(function(fs){
      var legend=fs.querySelector('legend');
      if(!legend){return;}
      var name=legend.getAttribute('data-rr-name')||legend.textContent.trim();
      legend.setAttribute('data-rr-name',name);
      var key=name.toLowerCase();
      var inputs=fs.querySelectorAll('input[type=radio]');
      if(!started&&!hasParam&&inputs.length>1&&FORCE.indexOf(key)>-1){pending[key]=true;}
      if(pending[key]){inputs.forEach(function(i){i.checked=false;});}
      var checked=fs.querySelector('input[type=radio]:checked');
      var sig=(pending[key]?'?':(checked?checked.value:''))+'|'+inputs.length;
      fs.setAttribute('data-rr-key',key);
      fs.classList.toggle('rr-opt--pending',!!pending[key]);
      if(legend.getAttribute('data-rr-sig')===sig){return;}
      legend.setAttribute('data-rr-sig',sig);
      legend.textContent='';
      var n=d.createElement('span');n.className='rr-opt__name';n.textContent=pending[key]?('choose your '+key):(key+':');
      var v=d.createElement('span');v.className='rr-opt__val';v.textContent=pending[key]?'':(checked?checked.value:'');
      var c=d.createElement('span');c.className='rr-opt__count';c.textContent=inputs.length+' options';
      legend.appendChild(n);legend.appendChild(v);legend.appendChild(c);
    });
    started=true;
    var k=firstPending();
    if(k){
      btn.removeAttribute('disabled');
      btn.setAttribute('aria-disabled','true');
      btn.setAttribute('data-rr-pending','true');
      var text='choose a '+k;
      if(btnLabel().textContent.trim()!==text){btnLabel().textContent=text;}
    }
  }

  d.addEventListener('change',function(e){
    var fs=e.target.closest&&e.target.closest('fieldset[data-rr-key]');
    if(!fs){return;}
    delete pending[fs.getAttribute('data-rr-key')];
    if(!firstPending()&&btn.getAttribute('data-rr-pending')){
      btn.removeAttribute('data-rr-pending');
      btn.removeAttribute('aria-disabled');
      if(window.variantStrings&&window.variantStrings.addToCart){btnLabel().textContent=window.variantStrings.addToCart;}
    }
    setTimeout(decorate,0);
  },true);

  /* tapping the button before choosing points back at the options */
  btn.addEventListener('click',function(e){
    var k=firstPending();
    if(!k){return;}
    e.preventDefault();e.stopPropagation();
    var fs=info.querySelector('fieldset[data-rr-key=\''+k+'\']');
    if(!fs){return;}
    fs.scrollIntoView({behavior:'smooth',block:'center'});
    fs.classList.remove('rr-opt--nudge');
    void fs.offsetWidth;
    fs.classList.add('rr-opt--nudge');
  },true);

  decorate();
  if('MutationObserver' in window){
    var t2;
    new MutationObserver(function(){clearTimeout(t2);t2=setTimeout(decorate,40);}).observe(info,{childList:true,subtree:true});
  }

  /* ---- sticky add-to-cart bar ---- */
  if(!('IntersectionObserver' in window)){return;}
  var titleEl=d.querySelector('.product__title h1');
  var bar=d.createElement('div');
  bar.className='rr-sticky';
  bar.setAttribute('aria-hidden','true');
  var box=d.createElement('div');
  var ttl=d.createElement('span');ttl.className='rr-sticky__title';ttl.textContent=titleEl?titleEl.textContent.trim():'';
  var prc=d.createElement('span');prc.className='rr-sticky__price';
  box.appendChild(ttl);box.appendChild(prc);
  var go=d.createElement('button');go.type='button';go.className='rr-btn';go.tabIndex=-1;
  bar.appendChild(box);bar.appendChild(go);
  d.body.appendChild(bar);

  function sync(){
    var p=d.querySelector('.product__info-container .price--on-sale .price-item--sale')||d.querySelector('.product__info-container .price-item--regular');
    prc.textContent=p?p.textContent.trim():'';
    go.textContent=btnLabel().textContent.trim().toLowerCase();
    go.disabled=btn.disabled;
  }
  go.addEventListener('click',function(){
    if(btn.disabled){btn.scrollIntoView({behavior:'smooth',block:'center'});return;}
    btn.click();
  });
  new IntersectionObserver(function(entries){
    var e=entries[0];
    var on=!e.isIntersecting&&e.boundingClientRect.top<0;
    if(on){sync();}
    bar.classList.toggle('is-on',on);
    go.tabIndex=on?0:-1;
    bar.setAttribute('aria-hidden',on?'false':'true');
  }).observe(btn);
  d.addEventListener('change',function(e){if(e.target.closest&&e.target.closest('variant-selects,variant-radios,.product-form__input')){setTimeout(sync,500);}});
})();
